import { showToast } from "services/utils/Status";
import { redirectToLogin } from "services/utils/sessionLifecycle";

let redirectPending = false;

export default function sessionHandling(requestToken = localStorage.getItem("token")) {
  const storedToken = localStorage.getItem("token");
  if (redirectPending) return;
  // No stored token means another tab logged out: still send this tab to login.
  if (!storedToken) {
    redirectToLogin();
    return;
  }
  // Ignore stale responses from a request made before a different login.
  if (requestToken && requestToken !== storedToken) return;
  redirectPending = true;
  localStorage.clear();
  showToast(
    "error",
    "You have logged in from another device, so this session will be signed out.",
    {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );

  // Redirect to login after a delay
  setTimeout(() => {
    redirectPending = false;
    if (localStorage.getItem("token")) return;
    localStorage.setItem("LoginTag", "Email");
    window.location.replace("/auth/login");
  }, 2000);
}
